import { render } from "./PdfDataSectionSummary.vue?vue&type=template&id=041178a5&scoped=true&ts=true"
import script from "./PdfDataSectionSummary.vue?vue&type=script&lang=ts"
export * from "./PdfDataSectionSummary.vue?vue&type=script&lang=ts"

import "./PdfDataSectionSummary.vue?vue&type=style&index=0&id=041178a5&scoped=true&lang=scss"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041178a5"]])

export default __exports__